var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-progress-linear',{staticStyle:{"margin":"0","z-index":"9999","position":"fixed"},attrs:{"indeterminate":_vm.loading,"height":"2","color":"orange"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }